<template>
  <div class="other-content">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="商品编码" prop="skuCodes">
          <el-input v-model="searchForm.skuCodes" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="商品名称" prop="skuName">
          <el-input v-model.trim="searchForm.skuName" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="紧急程度" prop="emergency">
          <el-select v-model="searchForm.emergency" clearable @change="onSearch">
            <el-option label="紧急" value="1"></el-option>
            <el-option label="不紧急" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整内容：" prop="adjustContentQuery" v-if="!hideAdjustContentFilter">
          <el-select v-model="searchForm.adjustContentQuery" clearable @change="onSearch">
            <el-option label="销售状态" value="销售状态"></el-option>
            <el-option label="发货周期" value="发货周期"></el-option>
            <el-option label="是否松木" value="是否松木"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整备注" prop="adjustRemark">
          <el-input v-model.trim="searchForm.adjustRemark" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="调整时间">
          <form-date-range :form="searchForm" startKey="adjustDateStart" endKey="adjustDateEnd" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">查询</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>

    <el-row class="tabs-row">
      <el-col :span="10">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs">
          <template v-if="storeTabs.length">
            <el-tab-pane
              v-for="(tab, index) in storeTabs"
              :key="index"
              :label="tab.label + (tab.count > 0 ? ' ' + tab.count : '')"
              :name="tab.name"
              :disabled="loading && tab.name != activeTab"
            ></el-tab-pane>
          </template>
          <div v-else class="occupy"></div>
        </el-tabs>
      </el-col>
      <el-col :span="14" class="table-btn-area">
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>

    <table-panel ref="tablePanel">
      <vxe-table
        stripe
        border
        ref="tableRef"
        :data="tableData.list"
        :height="maxTableHeight"
        :cell-style="cellStyle"
        v-if="tableReload"
        v-loading="loading"
        empty-text="暂无数据"
        @checkbox-change="handleSelectionChange"
        @checkbox-all="handleSelectionChange"
      >
        <vxe-column type="checkbox" width="39"></vxe-column>
        <vxe-column field="emergency" title="紧急程度" min-width="80" show-overflow></vxe-column>
        <vxe-column field="skuCode" title="商品编码" min-width="120" show-overflow></vxe-column>
        <vxe-column field="skuName" title="商品名称" min-width="150" show-overflow></vxe-column>
        <vxe-column field="noticeTime" title="通知时间" min-width="150" show-overflow></vxe-column>
        <vxe-column field="adjustContent" title="调整内容" min-width="150" show-overflow></vxe-column>
        <vxe-column field="adjustBefore" title="调整前" min-width="80" show-overflow></vxe-column>
        <vxe-column field="adjustAfter" title="调整后" min-width="80" show-overflow></vxe-column>
        <vxe-column field="adjustRemark" title="调整备注" min-width="120" show-overflow></vxe-column>
        <vxe-column field="name" title="调整人" min-width="80" show-overflow></vxe-column>
        <vxe-column field="creationDate" title="调整时间" min-width="150" show-overflow></vxe-column>
        <vxe-column field="operType" title="操作类型" min-width="80" show-overflow></vxe-column>
        <vxe-column field="operName" title="操作人" min-width="80" show-overflow></vxe-column>
        <vxe-column field="lastUpdateDate" title="操作时间" min-width="150" show-overflow></vxe-column>
      </vxe-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[100, 200, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';

export default {
  name: 'OtherContent',
  mixins: [tableMixin, pagePathMixin],
  props: {
    adjustContent: {
      type: String,
      default: '其他信息'
    },
    hideAdjustContentFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      selectedRows: [],
      searchForm: {
        skuCodes: '',
        skuName: '',
        adjustContentQuery: '',
        adjustRemark: '',
      },
      activeTab: undefined,
      storeTabs: [],
      tableVisible: false,
    };
  },
  mounted() {
    this.getStroeTab();
  },
  methods: {
    getStroeTab() {
      this.loading = true;
      const data = new FormData();
      data.append('adjustContent', this.adjustContent);
      data.append('status', 2);
      this.$q.newProduct.storeStatics({ data: data }).then((res) => {
        this.storeTabs = res.data.map((v) => ({
          label: v.storeName,
          name: v.storeCode,
          count: v.qty,
        }));
        if (!this.storeTabs || !this.storeTabs.length) {
          this.loading = false;
          this.tableData.total = 0;
          this.tableData.list = [];
          return;
        }
        let tabs = this.storeTabs.map((v) => v.name);
        this.activeTab = this.activeTab == 0 || !tabs.includes(this.activeTab) ? this.storeTabs[0].name : this.activeTab;
        this.$nextTick((_) => {
          this.onSearch();
        });
      });
    },

    handleTabClick() {
      this.onSearch();
    },

    // 处理状态切换
    handleProcessStatusChange() {
      this.tableData.pageNum = 1;
      this.getStroeTab();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let { skuCodes } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          storeCode: this.activeTab,
          adjustContent: this.adjustContent,
          status: 2,
          skuCodes: skuCodes ? skuCodes.split(' ') : [],
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .msgNoticePage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    onReset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection.records || selection;
    },

    // 批量已处理
    handleProcessing(row) {
      if (this.selectedRows.length === 0 && !row) {
        this.$message.warning('请先选择商品！');
        return;
      }
      const stroeName = this.storeTabs.find((item) => item.name === this.activeTab).label;
      this.$confirm(`确认该商品在"${stroeName}"已处理吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const ids = row ? [row.id] : this.selectedRows.map((item) => item.id);
          let data = {
            status: 1,
            ids,
          };
          this.$q.newProduct.msgNoticeDeal({ data: data }).then((res) => {
            if (res.success) {
              this.$message.success(`${!row ? '批量' : ''}已处理成功`);
              this.getNewTab();
            }
          });
        })
        .catch(() => {});
    },

    // 批量未上架
    batchListing(row) {
      if (this.selectedRows.length === 0 && !row) {
        this.$message.warning('请先选择商品');
        return;
      }
      const stroeName = this.storeTabs.find((item) => item.name === this.activeTab).label;
      this.$confirm(`确认该商品在"${stroeName}"未上架吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const ids = row ? [row.id] : this.selectedRows.map((item) => item.id);
          let data = {
            status: 2,
            ids,
          };
          this.$q.newProduct.msgNoticeDeal({ data: data }).then((res) => {
            if (res.success) {
              this.$message.success(`${!row ? '批量' : ''}未上架成功`);
              this.getNewTab();
            }
          });
        })
        .catch(() => {});
    },

    // 查看信息
    viewInfo(row) {
      // 查看信息逻辑
      this.$message.info('查看信息: ' + row.id);
    },

    getNewTab() {
      this.$emit('getNumber');
      this.getStroeTab();
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'onSaleExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    isShowTips(row, column) {
      let propList = row.fieldBOS ? row.fieldBOS.map((v) => v.field) : [];
      return propList && propList.includes(column.property);
    },

    getTips(row, column) {
      if (!row.fieldBOS) return;
      let propData = row.fieldBOS.find((v) => v.field == column.property);
      return `变更前：${propData.oldVal},变更后：${propData.newVal}`;
    },

    cellStyle({ row, column }) {
      if (row.emergency == '紧急') {
        return {
          color: '#F56C6C',
        };
      }
      return {};
    },

    closeAddForm() {
      this.tableVisible = false;
    },

    confirm() {
      this.tableVisible = false;
      this.tableReload = false;
      this.$nextTick(() => {
        this.tableReload = true;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.other-content {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}

.occupy {
  width: 200px;
  height: 20px
}

.table-btn-area {
  text-align: right;
  line-height: 40px;
}

.tagAlign {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

  >>> .form-number-input .el-input-number {
      width: 105px !important;
  }
  >>> .form-number-input .el-input-number .el-input {
      width: 105px !important;
  }
</style>
